<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :title="$t('labels.driverModule.license.edit')"
        :submit="visibleCreateLicense"
        :rules="rulesEditLicense"
        @close="closeOverSide">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="dataLicense.licenseNumber"
                    required
                    :label="$t('labels.driverModule.license.no')"
                    name="driverModule.license.no"
                    prop="driverModule.license.no" />
                <hts-form-select
                    v-model="dataLicense.licenseClass"
                    :label="$t('labels.driverModule.license.class')"
                    required
                    :items="license() || []"
                    key-id="key"
                    key-label="key"
                    key-tooltip="keyDes"
                    :color="color"
                    :multiple="true"
                    name="driverModule.license.class"
                    prop="driverModule.license.class" />
                <hts-form-date
                    v-model="dataLicense.expiredDate"
                    required
                    :label="$t('labels.driverModule.license.expires')"
                    :color="color"
                    name="driverModule.license.expires"
                    prop="driverModule.license.expires" />
            </div>
        </hts-card>

        <hts-card :title="$t('labels.driverModule.license.image')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-file
                    v-model="dataLicense.licenseFront"
                    type="file"
                    :label="$t('labels.driverModule.license.front')"
                    :color="color"
                    :required="dataLicense.licenseFront || dataLicense.licenseBack"
                    name="driverModule.license.front"
                    prop="driverModule.license.front"
                    field-name="licenseFront"
                    :file-name="dataLicense.licenseFrontOriginName" />

                <hts-form-file
                    v-model="dataLicense.licenseBack"
                    type="file"
                    :label="$t('labels.driverModule.license.back')"
                    :color="color"
                    :required="dataLicense.licenseFront || dataLicense.licenseBack"
                    name="driverModule.license.back"
                    prop="driverModule.license.back"
                    field-name="licenseBack"
                    :file-name="dataLicense.licenseBackOriginName" />
            </div>
        </hts-card>

        <hts-modal
            :show="openPopupConfirmLicense"
            :title="$t('labels.confirmEditLicense')"
            type="confirm"
            :content="$t('labels.contentConfirmExpiredDateLicense')"
            @hide="openPopupConfirmLicense = false"
            @confirm="submitFom" />
    </hts-drawer>
</template>

<script lang="ts" setup>
import form from './imports/form'
import data from './imports/data'
const { license } = data()
const props = defineProps({
  show: {
    type: Boolean,
    default: true,
    required: true
  },
  codeDriver: {
    type: String
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  },
  license: {
    type: Object
  }
})

const visible = ref(false)

const { show } = toRefs(props)

const licenseInfo: any = ref({})
const licenseId = ref()
const open = (data: { [key: string]: any }) => {
  licenseId.value = data._id
  visible.value = true
  Object.assign(dataLicense, data)
  dataLicense.licenseBack = null
  dataLicense.licenseFront = null
}
defineExpose({
  open
})
const _initForm = {
  licenseNumber: undefined,
  licenseClass: undefined,
  expiredDate: undefined,
  licenseFront: undefined,
  licenseBack: undefined
} as { [key: string]: any }

const dataLicense = reactive({ ..._initForm })
const rulesEditLicense = form.rulesEditLicense
const emits = defineEmits(['close', 'refreshTables', 'update:show'])

const loading = ref(false)

const openPopupConfirmLicense = ref(false)

const visibleCreateLicense = async () => {
  if (new Date(dataLicense.expiredDate + ' 23:59:59').getTime() < new Date().getTime()) {
    openPopupConfirmLicense.value = true
  } else {
    await submitFom()
  }
}

const submitFom = async () => {
  const dataForm = new FormData()
  // if ((dataLicense.licenseFront && !dataLicense.licenseBack) || (!dataLicense.licenseFront && dataLicense.licenseBack)) {
  //   process.client && $toast().error($t('labels.editSuccess'))
  // }

  dataForm.append('driver', props.codeDriver || '')
  dataForm.append('licenseNumber', dataLicense.licenseNumber)
  dataForm.append('licenseClass', JSON.stringify(dataLicense.licenseClass))
  dataForm.append('expiredDate', dataLicense.expiredDate)
  dataForm.append('files', dataLicense.licenseFront) // ảnh trước CMND là phần tử thứ nhất
  dataForm.append('files', dataLicense.licenseBack) // ảnh sau CMND là phần tử thứ 2
  const api = $url.driver.license.edit

  const data: any = await $api(api, { uriParams: { ID: licenseId.value }, body: dataForm })

  const resData: any = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.editSuccess'))
    emits('close')
    emits('refreshTables')
    closeOverSide()
    openPopupConfirmLicense.value = false
  }
}

const closeOverSide = () => {
  visible.value = false
}
</script>
